export default __webpack_public_path__ + "static/media/tervivc.282bd7b9.svg";